module.exports = require('./CardSkeleton')
